import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Grid from "../../../../components/Grid";
import { Tag } from "../../../../components/StyledComponents";
import Table from "../../../../components/Table";
import { Action, useActions } from "../../../../provider/ActionsProvider";
import { getAllPagos, getStatics } from "../../../../store/actions/pago";
import Filters from "./components/Filters";
import { GetAllPagosInDto } from "../../../../types/pago.dto";
import { dateSpliter } from "../../../../helpers/data-handler";
import { argentinaPesos } from "../../../../helpers/loca-currency";
import { useLayout } from "../../../../provider/LayoutProvider";
import { TagSpan } from "./styles";
import SearchBar from "../../../../components/SearchBar";

interface ComponentProps {
	pagos: GetAllPagosInDto;
	pagosStates: {
		loading: boolean;
		success: boolean;
		error: boolean | string;
	};
	pagosStaticsStates: {
		loading: boolean;
		success: boolean;
		error: boolean | string;
	};
	pagosStatics;
}

const Component = ({
	pagos,
	pagosStates,
	pagosStatics,
	pagosStaticsStates,
}: ComponentProps) => {
	const { layout, setLayout } = useLayout();
	const { setActions, setFilters } = useActions();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [activeFilters, setActiveFilters] = useState();
	const savedFilters = JSON.parse(
		localStorage.getItem("pagos-filters") || "{}"
	);

	const actions = useMemo(
		(): Action[] => [
			{
				component: "link",
				label: "Nuevo pagos",
				href: "/dashboard/pagos/new",
				options: {
					type: "filled",
					size: "lg",
					skin: "primary",
				},
			},
		],
		[]
	);

	const columns = useMemo(
		() => [
			{
				Header: "Referencia",
				Cell: ({ row, value }) => {
					const newLine = row.original["new-line"];
					return (
						<>
							<span>{value}</span>
							{newLine && <TagSpan>Automático</TagSpan>}
						</>
					);
				},
				accessor: "referencia",
			},
			{
				Header: "Concepto",
				Cell: ({ value }) => {
					if (!!value) {
						return (
							pagosStatics?.categories?.motivo?.filter(
								(motivo) => motivo.id === value
							)[0]?.text || ""
						);
					}
				},
				accessor: "motivo",
			},
			{
				Header: "Fecha Origen",
				Cell: ({ value }) => {
					if (!!value) {
						const dateSplitted = dateSpliter(value);
						return `${dateSplitted?.day?.name.short} ${dateSplitted?.day?.number} de ${dateSplitted?.month?.name?.short} del ${dateSplitted?.year}`;
					}
				},
				accessor: "fecha-origen-start",
			},
			{
				Header: "Monto",
				Cell: ({ value }) => {
					if (!!value) {
						return argentinaPesos(value, { showCurrency: true });
					}
				},
				accessor: "monto-total",
			},
			{
				Header: "Estado",
				Cell: ({ value }) => {
					if (!!value) {
						const item = pagosStatics?.categories?.status?.filter(
							(status) => status.id === value
						)[0];

						return (
							<Tag
								style={{
									...(!!item?.color && { backgroundColor: "#" + item?.color }),
								}}
							>
								{item?.text}
							</Tag>
						);
					}
				},

				accessor: "status",
			},
		],
		[pagosStatics]
	);

	const getElements = ({ page, limit, column, direction }) => {
		try {
			const finalColumn = column || savedFilters?.column;
			const finalDirection = direction || savedFilters?.direction;

			const updatedFilters = {
				...savedFilters,
				...(finalColumn ? { column: finalColumn } : {}),
				...(finalDirection ? { direction: finalDirection } : {})
			};

			localStorage.setItem("pagos-filters", JSON.stringify(updatedFilters));

			const filters = {
				...(activeFilters ?? {}),
				...updatedFilters,
			};

			dispatch(
				getAllPagos({
					page,
					limit,
					filters,
					query: updatedFilters.query,
				})
			);
		} catch (error) {}
	};

	const getElement = (row) => {
		navigate(`/dashboard/pagos/${row.original["item-id"]}`);
	};

	const search = (value) => {
		try {
			const updatedFilters = { ...savedFilters };
			localStorage.setItem("pagos-filters", JSON.stringify(updatedFilters));

			const payload: any = {
				page: 0,
				limit: 10,
				filters: activeFilters,
			};

			if (value) {
				payload.query = value;
			}

			dispatch(getAllPagos(payload));
		} catch (error) {}
	};

	useEffect(() => {
		setActions(actions);
		setFilters(<Filters setActiveFilters={setActiveFilters} />);
		!pagosStatics && dispatch(getStatics());
		setLayout({ ...layout, showBackButton: false });
	}, [pagos]);

	return (
		<Grid.ContainerFluid>
			<Grid.Row>
				<Grid.Col>
					<SearchBar onSearch={(value) => search(value)} />
					<Table
						columns={columns}
						data={pagos?.hints}
						pagination={pagos?.pagination}
						onRowClick={(row, index) => getElement(row)}
						fetchData={(data) => getElements(data)}
						loading={pagosStates?.loading || !pagos}
					/>
				</Grid.Col>
			</Grid.Row>
		</Grid.ContainerFluid>
	);
};

const states = ({ pagoStore }) => {
	const { data: pagos, states: pagosStates } = pagoStore.all;
	const { data: pagosStatics, states: pagosStaticsStates } = pagoStore.statics;

	return {
		pagos,
		pagosStates,
		pagosStaticsStates,
		pagosStatics,
	};
};

export default connect(states)(Component);
